export default __webpack_public_path__ + "static/media/x-menu-btn2.4c189aac.PNG";